// import packages
import axios from 'axios';

// import lib
import config from './index';
import { getAuthToken, removeAuthToken, setAuthToken } from '../lib/localStorage'

axios.defaults.baseURL = config.API_URL;
axios.defaults.headers.common['Authorization'] = getAuthToken();

export const setAuthorization = (token) => {
    setAuthToken(token)
    axios.defaults.headers.common['Authorization'] = token;
}

export const removeAuthorization = async () => {
    await removeAuthToken()
    delete axios.defaults.headers.common["Authorization"];
}

export const handleResp = (respData) => {
    try {
        if ([200, 400, 500].includes(respData.status)) return respData.data;
        if (respData && respData.status === 401) {
            // removeAuthorization();
            // return window.location.href = '/login';
        }
    } catch (err) {
        console.log(err, '----errr')
        // removeAuthorization();
        // return window.location.href = '/login';
    }
}

export default axios;